import { useTranslation } from 'react-i18next';
import CardContent from '@mui/material/CardContent';
import customTwMerge from 'utils/twMerge';
import { CCard, CCardMedia } from 'components/atoms';
import { PresetCardProps } from 'types/molecules';

export default function PresetCard({
  title,
  imgSrc,
  containerClassName,
  imgClassName,
  className,
  type,
  children,
  onClick,
}: PresetCardProps) {
  const { t } = useTranslation(['translation', 'common']);

  const preset = {
    doctor: {
      src: new URL('assets/svg/stethoscope-dot.svg', import.meta.url).href,
      title: t('not-found.doctor'),
    },
    result: {
      src: new URL('assets/svg/magnifier-dot.svg', import.meta.url).href,
      title: t('not-found.result'),
    },
    department: {
      src: new URL('assets/svg/category-dot.svg', import.meta.url).href,
      title: t('not-found.department'),
    },
    'pet-mate': {
      src: new URL('assets/svg/paw-dot.svg', import.meta.url).href,
      title: t('not-found.pet-mate'),
    },
    address: {
      src: new URL('assets/svg/location-dot.svg', import.meta.url).href,
      title: t('not-found.address'),
    },
    'health-knowledge': {
      src: new URL('assets/svg/book-dot.svg', import.meta.url).href,
      title: t('not-found.health-knowledge'),
    },
    'coming-soon': {
      src: new URL('assets/svg/coming-soon.svg', import.meta.url).href,
      title: t('common:coming-soon'),
    },
    checkout: {
      src: new URL('assets/svg/checkout-dot.svg', import.meta.url).href,
      title: t('not-found.checkout'),
    },
    file: {
      src: new URL('assets/svg/folder-dot.svg', import.meta.url).href,
      title: t('not-found.file'),
    },
    notification: {
      src: new URL('assets/svg/notification-dot.svg', import.meta.url).href,
      title: t('not-found.notification'),
    },
    success: {
      src: new URL('assets/svg/success.svg', import.meta.url).href,
      title: t('common:successful'),
    },
    warning: {
      src: new URL('assets/svg/warning.svg', import.meta.url).href,
      title: t('error.unexpected'),
    },
    error: {
      src: new URL('assets/svg/error.svg', import.meta.url).href,
      title: t('error.unexpected'),
    },
    'membership-programs': {
      src: new URL('assets/svg/star-dot.svg', import.meta.url).href,
      title: t('not-found.membership-programs'),
    },
    'membership-purchase': {
      src: new URL('assets/svg/medal-star.svg', import.meta.url).href,
      title: t('not-found.membership-purchase'),
    },
    'membership-plans': {
      src: new URL('assets/svg/medal-star.svg', import.meta.url).href,
      title: t('not-found.membership-plans'),
    },
    'health-expenditure': {
      src: new URL('assets/svg/star-dot.svg', import.meta.url).href,
      title: t('not-found.health-expenditure'),
    },
  };

  const presetType = type && preset[type];

  return (
    <CCard className={containerClassName} onClick={onClick}>
      <CardContent
        className={customTwMerge(
          'flex flex-col items-center gap-10 p-10 text-center last:pb-10',
          className
        )}
      >
        {imgSrc ? (
          <CCardMedia
            imgSrc={imgSrc}
            alt={title ?? ''}
            containerClassName={customTwMerge('w-24', imgClassName)}
          />
        ) : type ? (
          <img
            className={customTwMerge('w-24', imgClassName)}
            src={presetType?.src}
            alt={presetType?.title}
          />
        ) : null}

        {title ? (
          <h5 className="text-label20 text-neutral-400">{title}</h5>
        ) : type ? (
          <h5 className="text-label20 text-neutral-400">{presetType?.title}</h5>
        ) : null}

        {children}
      </CardContent>
    </CCard>
  );
}

